import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Quotes from "../pages/Quotes";
import Customers from "../pages/Customers";
import Services from "../pages/Services";
import Locations from "../pages/Locations";
import Reports from "../pages/Reports";
import PropertyTypes from "../pages/masters/PropertyTypes";
import MovingTypes from "../pages/masters/MovingTypes";
import LoadTypes from "../pages/masters/LoadTypes";
import ServiceCategories from "../pages/masters/ServiceCategories";
import AdditionalServices from "../pages/masters/AdditionalServices";
import PackageTypes from "../pages/masters/PackageTypes";
import QuoteStatus from "../pages/masters/QuoteStatus";

import BackofficeLayout from "../layout/BackofficeLayout";
export default function BackofficeRoutes() {
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route element={<BackofficeLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="quotes" element={<Quotes />} />
                <Route path="customers" element={<Customers />} />
                <Route path="services" element={<Services />} />
                <Route path="locations" element={<Locations />} />
                <Route path="reports" element={<Reports />} />
                <Route path="masters/house-types" element={<PropertyTypes />} />
                <Route path="masters/moving-types" element={<MovingTypes />} />
                <Route path="masters/load-types" element={<LoadTypes />} />
                <Route path="masters/service-categories" element={<ServiceCategories />} />
                <Route path="masters/additional-services" element={<AdditionalServices />} />
                <Route path="masters/package-types" element={<PackageTypes />} />
                <Route path="masters/quote-status" element={<QuoteStatus />} />

            </Route>
            <Route path="*" element={<Navigate to="/backoffice/login" replace />} />
        </Routes>
    );
}